import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import Cookies from "js-cookie";
// import { clearCurrentUser, useStore } from "@/store/index";
// import { useStore } from "@/store/index";
// import { CurrentUser } from "@/types/general";
import { TRFlag, ENFlag } from "@/components/icons/";
import Popover from "@/components/ui/popover";
import NotificationBell from "@/features/notifications/components/NotificationBell";
import styles from "./index.module.scss";
// import photoImage from "@/assets/photo.png";

export interface HeaderProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const LANGUAGES = [
  { code: "tr", label: "Türkçe", Flag: TRFlag },
  { code: "en", label: "English", Flag: ENFlag },
] as const;

const Header: React.FC<HeaderProps> = ({
  title,
  description,
  icon,
  children,
  className = "",
}) => {
  const { t, i18n } = useTranslation();
  const [languagePopoverOpen, setLanguagePopoverOpen] = useState(false);
  const currentLang =
    LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];
  const CurrentFlag = currentLang.Flag;
  //   const navigate = useNavigate();

  // Profile states
  const [showProfilePopover, setShowProfilePopover] = useState(false);
  //   const [avatarUrl, setAvatarUrl] = useState<string | undefined>();
  //   const [isAvatarLoading /* setIsAvatarLoading */] = useState(true);
  //   const [currentUser /* setCurrentUser */] = useState<CurrentUser | null>(null);
  //   const isStaff = useStore((state) => state.isStaff);
  const profileRef = useRef<HTMLDivElement>(null);

  //   const toggleProfilePopover = (event?: React.MouseEvent) => {
  //     if (event) {
  //       event.stopPropagation();
  //       event.preventDefault();
  //     }

  //     setShowProfilePopover((prev) => !prev);
  //   };

  //   const handleLogout = () => {
  //     localStorage.removeItem("token");
  //     Cookies.remove("token");
  //     Cookies.remove("hiddenAnnouncements");
  //     clearCurrentUser();
  //     setShowProfilePopover(false);
  //     navigate("/login");
  //   };

  /*     useEffect(() => {
        fetchProfile()
    }, []) */

  //   useEffect(() => {
  //     if (currentUser) {
  //       let photoUrl = "/assets/avatar.svg";
  //       if (isStaff && currentUser.photo) {
  //         photoUrl = currentUser.photo;
  //       } else if (!isStaff && currentUser.staff?.photo) {
  //         photoUrl = currentUser.staff.photo;
  //       }
  //       //   setAvatarUrl(photoUrl);
  //     }
  //   }, [currentUser, isStaff]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        showProfilePopover &&
        profileRef.current &&
        !profileRef.current.contains(event.target as Node)
      ) {
        setShowProfilePopover(false);
      }
    };

    if (showProfilePopover) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfilePopover]);

  return (
    <header className={`${styles.headerTopbar} ${className}`}>
      <div className={styles.headerTopbarLeft}>
        <div className={styles.headerTopbarLeftContent}>
          {icon && <div className={styles.headerTopbarLeftIcon}>{icon}</div>}
          {(title || description) && (
            <div className={styles.headerTopbarLeftText}>
              {title && (
                <h1 className={styles.headerTopbarLeftTitle}>{t(title)}</h1>
              )}
              {description && (
                <p className={styles.headerTopbarLeftDescription}>
                  {t(description)}
                </p>
              )}
            </div>
          )}
        </div>
        {children}
      </div>
      {/* <div className={styles.headerTopbarRight}>
        <div
          className={`${styles.headerTopbarActionsProfile} ${showProfilePopover ? styles.active : ""}`}
          ref={profileRef}
        >
          <div
            className={styles.profileTrigger}
            onClick={(e) => toggleProfilePopover(e)}
          >
            {isAvatarLoading ? (
              <div className={styles.avatarLoadingSpinner}></div>
            ) : (
              avatarUrl && (
                <img
                  className={styles.headerTopbarActionsProfileImage}
                  src={avatarUrl || "/assets/avatar.svg"}
                  alt="Profile"
                />
              )
            )}
            {currentUser && (
              <div className={styles.headerTopbarActionsProfileInfo}>
                <p className={styles.profileName}>
                  {currentUser.name} {currentUser.surname}
                </p>
                <p className={styles.profileEmail}>{currentUser.email}</p>
              </div>
            )}
            <div
              className={`${styles.profileArrow} ${showProfilePopover ? styles.open : ""}`}
            >
              <ArrowDown width={16} height={16} />
            </div>
          </div>
          {showProfilePopover && (
            <div className={styles.profilePopover}>
              <ul>
                <li>
                  <a href="/profile">
                    <Settings
                      width={24}
                      height={24}
                      className={styles.menuIcon}
                    />
                    {t("settingsPage")}
                  </a>
                </li>
                <li className={styles.divider}></li>
                <li className={styles.logoutItem} onClick={handleLogout}>
                  <Logout width={24} height={24} className={styles.menuIcon} />
                  {t("logout")}
                </li>
              </ul>
            </div>
          )}
        </div>
      </div> */}
      <div className={styles.headerTopbarRight}>
        <div className={styles.headerTopbarRightItem}>
          {/* <div className={styles.headerTopbarRightItemAvatar}>
            <img src={photoImage} alt="User Avatar" />
          </div> */}
        </div>
        <div className={styles.headerTopbarRightItem}>
          <NotificationBell />
        </div>
        <div className={styles.headerTopbarRightItem}>
          <Popover
            content={
              <div className={styles.languageMenu}>
                <div className={styles.languageMenuHeader}>
                  {t("common.language")}
                </div>
                {LANGUAGES.map((lang) => {
                  const FlagIcon = lang.Flag;
                  return (
                    <button
                      key={lang.code}
                      type="button"
                      className={`${styles.languageMenuItem} ${i18n.language === lang.code ? styles.languageMenuItemActive : ""}`}
                      onClick={() => {
                        i18n.changeLanguage(lang.code);
                        localStorage.setItem("selectedLanguage", lang.code);
                        setLanguagePopoverOpen(false);
                      }}
                    >
                      <span className={styles.languageMenuFlag}>
                        <FlagIcon
                          width={24}
                          height={24}
                          preserveAspectRatio="xMidYMid meet"
                        />
                      </span>
                      <span>{lang.label}</span>
                    </button>
                  );
                })}
              </div>
            }
            isOpen={languagePopoverOpen}
            onClose={() => setLanguagePopoverOpen(false)}
            position="bottom"
          >
            <button
              type="button"
              className={styles.languageButton}
              onClick={() => setLanguagePopoverOpen(!languagePopoverOpen)}
              aria-label={t("common.language")}
            >
              <span className={styles.languageButtonLabel}>{t("common.language")}</span>
              <span className={styles.languageButtonFlag}>
                <CurrentFlag width={24} height={24} />
              </span>
            </button>
          </Popover>
        </div>
      </div>
    </header>
  );
};

export default Header;
